<template>
  <div>
    <div class="bg flex item-center flex-between">
      <el-button
          size="small"
          type="primary"
          @click="addlabeGroup"
      >添加标签组</el-button
      >
      <div>
        <el-input
            clearable
            v-model.trim="searchCondition.groupName"
            placeholder="请输入标签组名称"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search"
        >查询</el-button
        >
      </div>
    </div>
    <hm-content class="mt10">
      <div class="table mb20">
        <el-table
            stripe
            border
            ref="brandTable"
            :data="list"
            style="width: 100%"
            id="table"
            size="small"
        >
          <el-table-column
              type="index"
              label="序号"
              :index="index => index + (currentPage - 1) * pageSize + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="groupName"
              label="标签组名称"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="createTime"
              label="创建时间"
          >
          </el-table-column>
          <el-table-column
              prop="操作"
              header-align="center"
              align="center"
              width="180"
              label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                    type="text"
                    size="small"
                    class="blue"
                    @click="editGroup(scope.row)"
                >
                  编辑
                </el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button
                    type="text"
                    size="small"
                    class="blue"
                    @click="details(scope.row)"
                >
                  详情
                </el-button>
                <el-divider direction="vertical"></el-divider>
                <el-button
                    type="text"
                    size="small"
                    @click="delGroup(scope.row)"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="hm-pagination mb20">
        <el-pagination
            background
            :total="total"
            @current-change="paging"
            @size-change="handleSizeChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentPage"
        ></el-pagination>
      </div>
    </hm-content>

    <!--  新增编辑弹窗  -->
    <el-dialog :title="title" width="800" :visible.sync="dialogFormVisible" @close="resetForm">
      <el-form :model="dialogForm" :rules="rules" ref="ruleForm" class="mt20" label-width="150px">
        <el-form-item label="标签组名称" prop="groupName">
          <el-input v-model="dialogForm.groupName" size="small" clearable placeholder="请输入标签组名称"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex item-center flex-center">
        <el-button size="small" @click="dialogFormVisible = false">取 消</el-button>
        <el-button size="small" type="primary" @click="submitAddOrEdit">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 分组详情弹窗 -->
    <el-dialog width="1200" :visible.sync="dialogDetailsVisible">
      <div slot="title" >
        <span style="font-size:18px">详情</span>
        <span class="form-red">{{ currentRow.groupName }}</span>
      </div>
      <div class="mt20 flex flex-between item-center">
        <el-button
            size="small"
            type="primary"
            @click="addHasLabel"
        >添加已有标签</el-button
        >
        <div>
          <el-input
              clearable
              v-model.trim="detailsTableSearchCondition.labelName"
              placeholder="请输入标签名称"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="queryDetailsTableList"
          >查询</el-button
          >
        </div>
      </div>
      <div class="table mb20 mt20">
        <el-table
            stripe
            border
            ref="brandTable"
            :data="detailsTableList"
            style="width: 100%"
            id="table"
            size="small"
        >
          <el-table-column
              type="index"
              label="序号"
              :index="index => index + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="labelName"
              label="标签名称"
          >
          </el-table-column>
          <el-table-column
              prop="操作"
              header-align="center"
              align="center"
              width="120"
              label="操作">
            <template slot-scope="scope">
              <div class="flex flex-center item-center">
                <el-button
                    type="text"
                    size="small"
                    @click="delLabel(scope.row)"
                >
                  删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer flex item-center flex-center">
        <el-button size="small" type="primary" @click="dialogDetailsVisible = false">确 定</el-button>
        <el-button size="small" @click="dialogDetailsVisible = false">取 消</el-button>
      </div>


      <!-- 添加标签弹窗 -->
      <el-dialog title="添加已有标签" width="800" :visible.sync="dialogLabelVisible" :append-to-body="true">
        <div class="mt20 flex item-center flex-start">
          <el-input
              clearable
              style="width: 150px"
              v-model.trim="dialogLabelCondition.labelName"
              placeholder="请输入标签名称"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-button type="primary" size="small" @click="labelPaging(1)"
          >查询</el-button
          >
        </div>
        <div class="table mb20 mt20">
          <el-table
              stripe
              border
              ref="brandTable"
              :data="dialogLabelList"
              style="width: 100%"
              id="table"
              size="small"
              @selection-change="handleSelectionChange">
          >
            <el-table-column
                type="selection"
                width="55">
            </el-table-column>
            <el-table-column
                type="index"
                label="序号"
                :index="index => index + (dialogLabelCurrentPage - 1) * dialogLabelPageSize + 1"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                prop="labelName"
                label="标签名称"
            >
            </el-table-column>
          </el-table>
        </div>
        <div class="hm-pagination mb20">
          <el-pagination
              background
              :total="dialogLabelTotal"
              @current-change="labelPaging"
              @size-change="labelHandleSizeChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="dialogLabelCurrentPage"
          ></el-pagination>
        </div>
        <div slot="footer" class="dialog-footer flex item-center flex-center">
          <el-button size="small" type="primary" @click="submitAddLabelList">确 定</el-button>
          <el-button size="small" @click="dialogLabelVisible = false">取 消</el-button>
        </div>
      </el-dialog>
    </el-dialog>


  </div>

</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      title: "",
      type: "",
      dialogFormVisible: false,
      dialogForm: {
        groupName: "",
        groupId: ""
      },
      rules: {
        groupName: [
          { required: true, message: '请输入标签组名称', trigger: 'blur' }
        ],
      },
      currentRow: {},
      dialogDetailsVisible: false,
      detailsTableList: [],
      detailsTableSearchCondition: {
        labelName: ""
      },
      dialogLabelVisible: false,
      dialogLabelList: [],
      dialogLabelCurrentPage: 1,
      dialogLabelPageSize: 10,
      dialogLabelTotal: 0,
      dialogLabelCondition: {
        labelName: ""
      },
      multipleSelection: []
    };
  },
  created() {},
  mounted() {
    this.queryList();
  },
  methods: {
    async submitAddLabelList() {
      if (!this.multipleSelection || this.multipleSelection.length < 1) {
        this.$message({
          type: "warning",
          message: "请选择需要添加的标签!"
        });
        return;
      }
      let params = JSON.parse(JSON.stringify(this.multipleSelection));
      params.forEach(v => {
        v.groupId = this.currentRow.groupId;
      });
      await this.$store.dispatch("saveBatchLabelToGroup", params);
      this.$message({
        type: "success",
        message: "操作成功!"
      });
      this.dialogLabelVisible = false;
      this.queryDetailsTableList();
    },
    addHasLabel() {
      this.dialogLabelCurrentPage = 1;
      this.dialogLabelPageSize = 10;
      this.dialogLabelCondition.labelName = "";
      this.queryHasLabelList();
      this.dialogLabelVisible = true;
    },
    async queryHasLabelList() {
      const params = {
        pageSize: this.dialogLabelPageSize,
        pageNo: this.dialogLabelCurrentPage,
        groupId: this.currentRow.groupId,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.dialogLabelCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryHasLabelLis", params);
      if (code === "0") {
        const { total, records } = result;
        this.dialogLabelList = records;
        this.dialogLabelTotal = total;
      }
    },
    labelPaging(page) {
      this.dialogLabelCurrentPage = page;
      this.queryHasLabelList();
    },
    labelHandleSizeChange(size) {
      this.dialogLabelCurrentPage = 1;
      this.dialogLabelPageSize = size;
      this.queryHasLabelList();
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    details(row) {
      this.currentRow = row;
      this.detailsTableCurrentPage = 1;
      this.detailsTableSearchCondition.labelName = "";
      this.queryDetailsTableList();
      this.dialogDetailsVisible = true;
    },
    async delLabel(row) {
      const result = await this.$confirm("是否删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      console.log("删除result", result);
      if (result === "confirm") {
        await this.$store.dispatch("deleteLabelGroupToGroup", {
          groupId: this.currentRow.groupId,
          labelId: row.labelId
        });
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryDetailsTableList();
      }
    },
    async queryDetailsTableList() {
      this.detailsTableList = [];
      const params = {
        groupId: this.currentRow.groupId,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.detailsTableSearchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryGroupDetailLabelList", params);
      if (code === "0") {
        this.detailsTableList = result;
      }
    },

    async delGroup(row) {
      const result = await this.$confirm("是否删除本条数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      });
      console.log("删除result", result);
      if (result === "confirm") {
        await this.$store.dispatch("deleteLabelGroup", {
          groupId: row.groupId
        });
        this.$message({
          type: "success",
          message: "操作成功"
        });
        this.queryList();
      }
    },
    editGroup(row) {
      this.currentRow = row;
      this.title = "编辑标签组";
      this.type = "edit";
      this.dialogFormVisible = true;
      this.dialogForm = JSON.parse(JSON.stringify(row));
    },
    resetForm() {
      this.$refs.ruleForm.resetFields();
      this.dialogForm.groupId = "";
    },
    async submitAddOrEdit() {
      let params = JSON.parse(JSON.stringify(this.dialogForm));
      let url = this.type == "add" ? "addLabelGroup" : "editLabelGroup";
      await this.$store.dispatch(url, params);
      this.$message({
        message: "操作成功！",
        type: "success"
      });
      this.dialogFormVisible = false;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    addlabeGroup() {
      this.title = "新建标签组";
      this.type = "add";
      this.dialogFormVisible = true;
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage,
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("queryLabelGroupList", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
  },
};
</script>

<style scoped lang="scss">
.bg {
  background-color: #fff;
  padding: 20px 30px;
}
</style>
